interface ListingGridProps {
  children: React.ReactNode
  columns?: 2 | 3
}

export function ListingGrid({ children, columns = 3 }: ListingGridProps) {
  const gridCols =
    columns === 2
      ? "grid-cols-1 md:grid-cols-2"
      : "grid-cols-1 md:grid-cols-2 lg:grid-cols-3"

  return <div className={`grid gap-6 ${gridCols}`}>{children}</div>
}
